module.exports = __webpack_public_path__ + "img/Teacher_invite_dark.372e1428.svg";